module.exports = __webpack_public_path__ + "img/39.a53d0f90.jpg";